module.exports = __webpack_public_path__ + "media/src/images/org_avatar_placeholder-5b578fe59c1e1044d94074ae2854da9d.png";